import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Tag, Carousel } from 'antd';
import { Icon, Modal as ModalMobile } from 'antd-mobile';
import { Markup } from 'interweave';
import * as SignalR from '@aspnet/signalr';
import IdleTimer from 'react-idle-timer';
import moment from 'moment';
import './HotelEvent.css';

const { Content } = Layout;
const confirmAlert = ModalMobile.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'loginStore',
    'webSettingStore',
    'CmsEventHotelStore'
)
@observer
class HotelEventDetailPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        const id = this.props.match.params.id;
        this.props.CmsEventHotelStore.getByIdAndLanguage(id);

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
        this.props.CmsEventHotelStore.resetData();
    }

    back = () => {
        this.props.history.push('/');
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            selectedeventHotel,
            selectedimages
        } = this.props.CmsEventHotelStore

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Layout className='stm-layout'>
                                            <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                            <Content>
                                                {/* Header */}
                                                <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                            background: activeTemplate.templateSetting.header.backgroundColor,
                                                            color: activeTemplate.templateSetting.header.color,
                                                            fontSize: activeTemplate.templateSetting.header.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                            </Col>
                                                            <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                <span>{webSettting.hotelEventText}</span>
                                                            </Col>
                                                            <Col span={4} />
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                {/* Body */}
                                                <>
                                                    {
                                                        selectedimages.length > 0
                                                            ?
                                                            <>
                                                                <>
                                                                    <Row>
                                                                        <Col span={24} className={selectedimages.length === 1 ? 'stm-margin-top-50' : 'stm-margin-top-50 stm-background-black'}>
                                                                            <Carousel>
                                                                                {
                                                                                    selectedimages.map(image => {
                                                                                        return (
                                                                                            <div key={image.id} className='stm-text-align-left'>
                                                                                                <Row className='stm-text-align-left'>
                                                                                                    <Col span={24} className='stm-background-black'>
                                                                                                        <img className='stm-width-100-percent stm-height-auto stm-hotel-event-image' src={image.url} alt={image.id} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Carousel>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                <>
                                                                    {
                                                                        selectedeventHotel.showBannerOnly
                                                                            ?
                                                                            null
                                                                            :
                                                                            <Row className='stm-margin-top-24 stm-background-white stm-padding-bottom-100'>
                                                                                <Col span={1} />
                                                                                <Col span={22} className='stm-margin-top-24 stm-background-white stm-padding-bottom-24'>
                                                                                    <div
                                                                                        className='stm-margin-bottom-16 stm-text-align-center'
                                                                                        style={{
                                                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                            color: activeTemplate.templateSetting.label.color,
                                                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                        }}
                                                                                    >
                                                                                        {selectedeventHotel.title}
                                                                                    </div>
                                                                                    <>
                                                                                        {
                                                                                            selectedeventHotel.showDate
                                                                                                ?
                                                                                                <Row className='stm-padding-bottom-20'>
                                                                                                    <Col span={11} className='stm-text-align-right'>
                                                                                                        <Tag
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                                            }}
                                                                                                            color={activeTemplate.templateSetting.header.backgroundColor}
                                                                                                        >
                                                                                                            <span>{moment(selectedeventHotel.startDate).format('DD MMMM YYYY')}</span>
                                                                                                        </Tag>
                                                                                                    </Col>
                                                                                                    <Col
                                                                                                        span={2}
                                                                                                        className='stm-text-align-center'
                                                                                                        style={{
                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                                        }}
                                                                                                    >
                                                                                                        <span>-</span>
                                                                                                    </Col>
                                                                                                    <Col span={11}>
                                                                                                        <Tag
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                                            }}
                                                                                                            color={activeTemplate.templateSetting.header.backgroundColor}
                                                                                                        >
                                                                                                            <span>{moment(selectedeventHotel.endDate).format('DD MMMM YYYY')}</span>
                                                                                                        </Tag>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                :
                                                                                                null
                                                                                        }
                                                                                    </>
                                                                                    <div
                                                                                        style={{
                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                                                                        }}
                                                                                    >
                                                                                        <Markup content={selectedeventHotel.description} />
                                                                                    </div>
                                                                                </Col>
                                                                                <Col span={1} />
                                                                            </Row>
                                                                    }
                                                                </>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                            </Content>
                                        </Layout>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default HotelEventDetailPage;
